class Modal {
    /**
     * Constructor
     * @param elementHitModal {object | string}
     * @requires Object.assign
     */
    constructor(elementHitModal) {
        /**
         * Config
         * @type {{duration: number, maxWidth: string}}
         */
        this.config = {
            maxWidth: '960px',
            duration: 200,
            nosScrollBodyModalOpen: true,
            mobileFullScreen: true
        };
        /**
         * @type Element | string
         */
        this.elementHitModal = elementHitModal;
        /**
         * @type {string}
         */
        this.target = typeof this.elementHitModal === 'object' && this.elementHitModal.getAttribute('data-modal-target');
        /**
         * @type {Element | undefined}
         */
        this.modal = document.querySelector(this.target || elementHitModal) || undefined;
        /**
         * @type {HTMLElement}
         */
        this.overlay = this.modal && this.modal.closest('.modal-overlay') || undefined;
        /**
         * @type {Element | undefined}
         */
        this.btnCloseModal = this.modal && this.modal.querySelector('.close-modal') || undefined;
        /**
         * @type {HTMLElement}
         */
        this.modalContent = undefined;
        /**
         * @type {string}
         */
        this.context = typeof this.elementHitModal === 'object' && this.elementHitModal.getAttribute('data-modal-context');
        /**
         * @type {string}
         * @requires Http
         */
        this.modalAsync = typeof this.elementHitModal === 'object' && this.elementHitModal.getAttribute('data-modal-async-url');
        /**
         * @type {boolean}
         */
        this.contentIsLoad = false;
        /**
         * Init
         */
        this._init();
    }

    /**
     * Set modal height
     * @param modal
     * @param fullHeight
     */
    static setModalHeight(modal, fullHeight) {
        const IS_MOBILE     = (window.innerWidth <= 768);
        const MODAL_HEIGHT  = (fullHeight && IS_MOBILE) ? window.outerHeight : modal.scrollHeight;
        const WINDOW_HEIGHT = window.innerHeight;

        if (fullHeight && IS_MOBILE) {
            modal.style.minHeight = WINDOW_HEIGHT + 'px';
            modal.style.maxHeight = WINDOW_HEIGHT + 'px';
        } else {
            modal.style.maxHeight = (MODAL_HEIGHT > WINDOW_HEIGHT) ? '100%' : MODAL_HEIGHT + "px";
        }
    }

    /**
     * Set modal height
     * @param modal
     * @param fullHeight
     */
    static setModalHeight(modal, fullHeight) {
        const IS_MOBILE     = (window.innerWidth <= 768);
        const MODAL_HEIGHT  = (fullHeight && IS_MOBILE) ? window.outerHeight : modal.scrollHeight;
        const WINDOW_HEIGHT = window.innerHeight;

        if (fullHeight && IS_MOBILE) {
            modal.style.minHeight = WINDOW_HEIGHT + 'px';
            modal.style.maxHeight = WINDOW_HEIGHT + 'px';
        } else {
            modal.style.maxHeight = (MODAL_HEIGHT > WINDOW_HEIGHT) ? '100%' : MODAL_HEIGHT + "px";
        }
    }

    /**
     * Init
     * @private
     */
    _init() {
        if (this.target) {
            this.elementHitModal.addEventListener('click', (e) => {
                this.open(e).then(this._updateContext.bind(this))
            });
        } else {
            this.open().then(this._updateContext.bind(this));
        }
        // Close listener
        this.btnCloseModal.addEventListener('click', () => this.close());
    }

    /**
     * Update context if any is given
     * @private
     */
    _updateContext() {
        // Check for any context to display or hide
        if (this.context) {
            const CONTEXTS = this.modal.querySelectorAll('.context.' + this.context);
            for (let i = 0; i < CONTEXTS.length; i++) {
                CONTEXTS[i].classList.add('show-context');
            }

            const CONTEXTS_TO_HIDE = this.modal.querySelectorAll('.context-' + this.context + '-hide');
            for (let i = 0; i < CONTEXTS_TO_HIDE.length; i++) {
                CONTEXTS_TO_HIDE[i].classList.add('hide-context');
            }

        } else {
            // Restore default modal content reverse what's done when a context is provided in the if above)
            const CONTEXTS = this.modal.querySelectorAll('.context.show-context');
            for (let i = 0; i < CONTEXTS.length; i++) {
                CONTEXTS[i].classList.remove('show-context');
            }

            const CONTEXTS_TO_HIDE = this.modal.querySelectorAll('.hide-context');
            for (let i = 0; i < CONTEXTS_TO_HIDE.length; i++) {
                CONTEXTS_TO_HIDE[i].classList.remove('hide-context');
            }
        }
    }

    /**
     * Create modal
     * @private
     */
    _createModal() {
        // Create element
        this.overlay                = document.createElement('div');
        this.modal                  = document.createElement('div');
        this.modalContent           = document.createElement('div');
        this.btnCloseModal          = document.createElement('button');
        // Add attribute
        this.overlay.id             = 'modal-overlay';
        this.modal.className        = 'modal';
        this.btnCloseModal.classNam = 'close-modal';
        this.btnCloseModal.type     = 'button';
        this.modalContent.className = 'block-white';
        // Style
        this.modal.style.transition = this.config.duration / 1000 + 's';
        // Close listener
        this.btnCloseModal.addEventListener('click', () => this.close());
        // Append element
        this.modal.appendChild(this.btnCloseModal);
        this.modal.appendChild(this.modalContent);
        this.overlay.appendChild(this.modal);
        document.body.insertBefore(this.overlay, document.body.firstChild);
    }

    /**
     * Animate In
     * @param callback
     * @private
     */
    _animateIn(callback) {
        this.modal.style.maxWidth = this.config.maxWidth;

        Modal.setModalHeight(this.modal, true);

        if (callback) {
            return setTimeout(() => callback(), this.config.duration)
        }
    }

    /**
     * Animate In
     * @param callback
     * @private
     */
    _animateOut(callback) {
        this.modal.style.maxWidth  = null;
        this.modal.style.maxHeight = null;
        if (callback) {
            return setTimeout(() => {
                callback()
            }, this.config.duration)
        }
    }

    /**
     * Open modal
     */
    open(e) {
        e && e.preventDefault();

        return new Promise((resolve, reject) => {
            const LOADER = new Loader();

            LOADER.show();

            if (this.config.nosScrollBodyModalOpen) {
                document.body.style.overflow = 'hidden';
                document.body.style.height   = '100%';
            }

            // Normal modal
            if (!this.modalAsync) {
                this.overlay.style.display  = 'block';
                this.modal.style.transition = this.config.duration / 1000 + 's';
                setTimeout(() => {
                    this._animateIn();
                    LOADER.hide();
                    resolve();
                }, 1);
            } else { // Async modal
                const HTTP = new Http();

                this._createModal();

                HTTP.ajax({url: '/' + this.modalAsync}).then((response) => {
                    this.modalContent.innerHTML = response;
                    this.contentIsLoad          = true;
                }).catch(() => {
                    this.modalContent.innerHTML = '<h2>Oups, une erreur est survenue</h2>'
                }).finally(() => {
                    const FORMS = this.modal.querySelectorAll('form');
                    if (FORMS) {
                        for (let i = 0; i < FORMS.length; i++) {
                            new AsyncForm(FORMS[i]);
                        }
                    }
                    LOADER.hide();
                    this._animateIn();
                    resolve();
                });
            }
        });
    }

    /**
     * Close modal
     */
    close() {
        if (this.config.nosScrollBodyModalOpen) {
            document.body.style.overflow = '';
            document.body.style.height   = '';
        }

        this.contentIsLoad = false;

        if (this.config.nosScrollBodyModalOpen) {
            document.body.addEventListener('touchmove', () => this.preventScroll(), false);
        }

        if (this.target) {
            this._animateOut(() => {
                this.overlay.style.display = 'none';
            });
            return
        }

        if (this.modalAsync) {
            this._animateOut(() => {
                this.overlay.parentNode.removeChild(this.overlay);
                this.elementHitModal.removeEventListener('click', () => this.open());
                this.btnCloseModal.removeEventListener('click', () => this.close());
            });
        }

    }

    /**
     * Check if modal content is loaded
     * @return {Promise}
     */
    contentLoaded() {
        return new Promise((resolve) => {
            setInterval(() => {
                if (this.contentIsLoad) {
                    return resolve();
                }
            }, 100);
        });
    }
}